export const CHIP = "inline-flex items-center rounded-md border border-line bg-surface-raised px-1.5 text-[13px] text-ink";

export const TABLE_HEAD = "border-b border-line px-1.5 py-1.5 text-left text-[13px] font-bold text-ink-muted";

export const TABLE_CELL = "border-b border-line px-1.5 py-1.5 align-middle";

// The header's outlined buttons; narrower than the sheet's 720 px (character_sheet.css) only their icon shows.
export const ACTION =
	"cs-tap inline-flex min-h-9 items-center gap-1.5 rounded-lg border border-line-strong bg-surface-raised px-2.5 text-sm font-bold text-ink hover:border-carmesim-600 hover:text-link";
